import { IColumnOption } from '../../interface/Column'

export const defaultColumnOption: Readonly<Required<IColumnOption>> = {
  count: 1,
  gap: 20,
  separator: false,
  separatorColor: '#000000',
  separatorWidth: 1
}